import { render, staticRenderFns } from "./force-diagram.vue?vue&type=template&id=984ad492"
import script from "./force-diagram.vue?vue&type=script&lang=js"
export * from "./force-diagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports